import React, { useState } from "react"
import { getEventInfoProdAccordion } from "@/components/ProductDetail/v3/ProductAccordionList/analytics"

const SetListData = props => {
  const {
    listData = [],
    showType,
    productAccordionText = {},
    productInfo,
    tabName = "",
  } = props

  const [viewMore, setViewMore] = useState({
    [productAccordionText.features]: false,
    [productAccordionText.technologies]: false,
    [productAccordionText.hydrotherapy]: false,
    [productAccordionText.material]: false,
    [productAccordionText.rebates]: false,
    [productAccordionText.installation]: false,
    [productAccordionText.props65Warning]: false,
  })

  const handleViewMoreClickAnalytics = () => {
    const kohlerDatalayer = window.kohler.datalayer
    kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
      eventMetaData: {
        experience: "pdp",
        eventType: "eventInfoProdAccordion",
        params: {
          type: productAccordionText.viewMore,
          tabName: tabName,
          needsJSON: true,
        },
      },
    })
  }

  return (
    <>
      <ul className="pdp-features-technologies__feature-list">
        {listData.map(
          (item, i) =>
            (i < 5 || (i > 4 && viewMore[showType])) && (
              <li key={i} className="pdp-features-technologies__list-item">
                {item}
              </li>
            )
        )}
      </ul>
      {listData.length > 5 && !viewMore[showType] && (
        <button
          className="pdp-features-technologies__view-more gbh-data-layer"
          tabIndex={0}
          aria-label={productAccordionText.viewMore}
          aria-disabled="false"
          data-gbh-data-layer={getEventInfoProdAccordion(
            productAccordionText.viewMore,
            tabName
          )}
          data-gbh-data-layer-custom={productInfo}
          onClick={() => {
            setViewMore({ ...viewMore, [showType]: true })
            handleViewMoreClickAnalytics()
          }}
        >
          {productAccordionText.viewMore}
        </button>
      )}
    </>
  )
}

export default SetListData
